import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges
} from '@angular/core';

declare let delta: any;

@Directive({
  selector: '[ngc-floatinglabel]',
  exportAs: 'ngcFloatingLabelDirective'
})
export class FloatingLabelDirective implements AfterViewInit, OnChanges {
  @Input('ngc-floatinglabel') labelvalue: string;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-placeholderValue') placeholderValue: string;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-data-value') datavalue: string;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-isRequired') isRequired = false;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-isOptional') isOptional = false;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-isOptionalforPlaceholder') isOptionalforPlaceholder = false;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-isRequiredforPlaceholder') isRequiredforPlaceholder = false;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-useDataValue') useDataValue = false;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-meeting-code-disclaimer') meetingCodeDisclaimer: string;
  // tslint:disable-next-line:no-input-rename
  @Input('ngc-show-edp-meeting-evt-msg') showEdpMeetingEvtMsg = false;
  // tslint:disable-next-line:no-input-rename
  private floatinglabel;
  private placeHolderLabel;
  private textLabel;
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('focus') onFocused() {
    this.showFloatingLabel();
  }

  @HostListener('focusout') onFocusout() {
    this.hideFloatingLabel();
  }

  ngAfterViewInit() {
    this.checkAndResetRequiredOptionalFlags();
    this.floatinglabel = this.renderer.createElement('label');
    const elem = this.elementRef.nativeElement;
    if (elem.id) {
      this.renderer.setAttribute(this.floatinglabel, 'for', elem.id.trim());
    }
    this.renderer.addClass(this.floatinglabel, 'floatinglabel');

    this.placeHolderLabel =
      this.placeholderValue || (elem.placeholder ?? '').trim();

    if (!this.labelvalue) {
      this.labelvalue = this.placeHolderLabel;
    }
    this.hideFloatingLabel();
    this.textLabel = this.renderer.createText(
      this.labelvalue +
        (this.isRequired === true ? ' (Vereist)' : '') +
        (this.isOptional === true ? ' (Optional)' : '')
    );
    this.renderer.appendChild(this.floatinglabel, this.textLabel);
    this.renderer.insertBefore(
      this.renderer.parentNode(elem),
      this.floatinglabel,
      elem
    );

    if (
      this.placeHolderLabel !== '' &&
      (this.isOptionalforPlaceholder === true ||
        this.isRequiredforPlaceholder === true)
    ) {
      this.placeHolderLabel =
        this.placeholderValue +
        (this.isRequiredforPlaceholder === true ? ' (Vereist)' : '') +
        (this.isOptionalforPlaceholder === true ? ' (Optional)' : '');

      this.renderer.setAttribute(
        elem,
        'placeholder',
        this.placeHolderLabel.trim()
      );
    }
  }

  showFloatingLabel() {
    this.renderer.removeClass(this.floatinglabel, 'invisible');
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'placeholder');
  }

  hideFloatingLabel() {
    if (this.useDataValue) {
      if (!this.datavalue) {
        this.renderer.addClass(this.floatinglabel, 'invisible');
      }
    } else {
      if (!this.elementRef.nativeElement.value) {
        this.renderer.addClass(this.floatinglabel, 'invisible');
        if (this.placeHolderLabel) {
          this.renderer.setAttribute(
            this.elementRef.nativeElement,
            'placeholder',
            this.placeHolderLabel.trim()
          );
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.checkAndResetRequiredOptionalFlags();
    if (
      changes['labelvalue'] &&
      changes['labelvalue'].previousValue !== changes['labelvalue'].currentValue
    ) {
      // aa prop changed
      if (this.floatinglabel) {
        this.renderer.removeChild(this.floatinglabel, this.textLabel);
      }
      this.textLabel = this.renderer.createText(
        this.labelvalue +
          (this.isRequired === true ? ' (Vereist)' : '') +
          (this.isOptional === true ? ' (Optional)' : '')
      );
      if (this.floatinglabel) {
        this.renderer.appendChild(this.floatinglabel, this.textLabel);
      }
    }
    if (
      this.showEdpMeetingEvtMsg &&
      this.meetingCodeDisclaimer &&
      this.floatinglabel
    ) {
      this.renderer.setAttribute(
        this.floatinglabel,
        'aria-label',
        this.labelvalue +
          (this.isRequired === true ? ' (Vereist)' : '') +
          (this.isOptional === true ? ' (Optional)' : '') +
          ' ' +
          this.meetingCodeDisclaimer.trim()
      );
    }
    if (
      changes['placeholderValue'] &&
      changes['placeholderValue'].previousValue !==
        changes['placeholderValue'].currentValue
    ) {
      this.placeHolderLabel =
        this.placeholderValue +
        (this.isRequiredforPlaceholder === true ? ' (Vereist)' : '') +
        (this.isOptionalforPlaceholder === true ? ' (Optional)' : '');
      this.renderer.setAttribute(
        this.elementRef.nativeElement,
        'placeholder',
        this.placeHolderLabel.trim()
      );
    }
    if (changes['datavalue'] && this.useDataValue && this.floatinglabel) {
      if (changes['datavalue']['currentValue']) {
        this.showFloatingLabel();
      } else {
        this.hideFloatingLabel();
      }
    }
  }

  checkAndResetRequiredOptionalFlags(): void {
    if (this.isRequired) {
      this.isOptional = false;
    }
    if (this.isRequiredforPlaceholder) {
      this.isOptionalforPlaceholder = false;
    }
  }
}
